import { AgGaugeOptions } from 'ag-charts-enterprise';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAbsentReportsQuery } from '../../hooks/queries/useDashboardQuery';
import GenericAgGauge from './GenericAgGauge';

interface PresenceRadialGaugeProps {
    today: string;
}

const PresenceRadialGauge: React.FC<PresenceRadialGaugeProps> = ({ today }) => {
    const { t } = useTranslation();

    const { data: dataAbsents } = useAbsentReportsQuery({ date: today });

    const options: AgGaugeOptions = {
        type: 'radial-gauge',
        value: 100 * (((dataAbsents?.reportsCount || 0) - (dataAbsents?.absentReportsCount || 0)) / (dataAbsents?.reportsCount || 1)),
        cornerRadius: 99,
        cornerMode: 'container',
        scale: {
            min: 0,
            max: 100,
            label: {
                enabled: false,
            },
        },

        label: {
            formatter({ value }) {
                return `${value.toFixed(0)}%`;
            },
        },
    };

    return <GenericAgGauge options={options} />;
};

export default PresenceRadialGauge;
